import * as React from 'react';
const Shuffle = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-shuffle", ...props },
    React.createElement("polyline", { points: "16 3 21 3 21 8" }),
    React.createElement("line", { x1: "4", y1: "20", x2: "21", y2: "3" }),
    React.createElement("polyline", { points: "21 16 21 21 16 21" }),
    React.createElement("line", { x1: "15", y1: "15", x2: "21", y2: "21" }),
    React.createElement("line", { x1: "4", y1: "4", x2: "9", y2: "9" })));
export default Shuffle;
//# sourceMappingURL=Shuffle.js.map